import { create } from 'zustand'
import { themeColorVariables, type ThemeMode } from './palettes'
import { readThemeMode, writeThemeMode } from './preference'

function initialMode(): ThemeMode {
  try {
    return readThemeMode(window.localStorage)
  } catch {
    return 'light'
  }
}

function applyTheme(mode: ThemeMode) {
  const root = document.documentElement
  root.dataset.theme = mode
  root.style.colorScheme = mode
  Object.entries(themeColorVariables(mode)).forEach(([name, value]) => root.style.setProperty(name, value))
}

const mode = initialMode()
// 在 React 首次绘制前应用，已选择深色时不先绘制浅色界面。
applyTheme(mode)

export const useThemeMode = create<{
  mode: ThemeMode
  setMode: (mode: ThemeMode) => void
}>((set) => ({
  mode,
  setMode: (next) => {
    applyTheme(next)
    set({ mode: next })
    try {
      writeThemeMode(window.localStorage, next)
    } catch {
      // localStorage 本身也可能被浏览器策略禁止访问。
    }
  },
}))
